<mat-icon class="flex-grow-0 flex-shrink-0" fontSet="fill">error</mat-icon>
<p class="pl-2 mb-0 lh-sm text-break">
  <ng-content></ng-content>
</p>